import React from 'react';
import DSSearchBox from '@elliemae/ds-basic/form/SearchBox';
import { ModalHeader, ModalHeaderTopRight } from '../blocks.js';
import { Title } from './Title.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

/* eslint-disable max-lines */
var SelectionHeader = function SelectionHeader(_ref) {
  var _ref$searchProps = _ref.searchProps,
      searchProps = _ref$searchProps === void 0 ? {} : _ref$searchProps,
      modalTitle = _ref.modalTitle,
      modalType = _ref.modalType,
      showClose = _ref.showClose;
  return /*#__PURE__*/React.createElement(ModalHeader, {
    classProps: {
      type: 'selection'
    }
  }, /*#__PURE__*/React.createElement(Title, {
    modalTitle: modalTitle,
    modalType: modalType
  }), showClose && /*#__PURE__*/React.createElement(ModalHeaderTopRight, {
    classProps: {
      type: 'selection'
    },
    "data-testid": "modal-search-box"
  }, /*#__PURE__*/React.createElement(DSSearchBox, searchProps)));
};

export default SelectionHeader;
export { SelectionHeader };
//# sourceMappingURL=SelectionHeader.js.map
